import React from "react";
import styled from "styled-components";
import { ReactComponent as AlertIcon } from "../../assets/svg/alert.svg";
import { ReactComponent as AlertIconSharp } from "../../assets/svg/alert-sharp.svg";
import { ReactComponent as InfoIcon } from "../../assets/svg/info.svg";
import colours from "../../lib/colours";
import CloseButton from "../atoms/CloseButton";

const CalloutContainer = styled.div`
  padding: 12px;
  display: flex;
`;

const TableCalloutContainer = styled.div`
  padding: 4px 6px;
  display: flex;
`;

const InnerContainer = styled.div``;

const TableInnerContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 4px;
`;

const IconContainer = styled.div`
  margin-right: 12px;
`;

const ButtonContainer = styled.div`
  margin-top: -8px;
  margin-right: -8px;
  margin-left: 4px;
`;

export const containerStyles: any = {
  info: {
    backgroundColor: `${colours.th1l5}`,
    color: `${colours.th1}`,
  },
  action: {
    backgroundColor: `${colours.th2l1}`,
    color: `${colours.th1}`,
  },
  warning: {
    backgroundColor: `${colours.th3l1}`,
    color: `${colours.th1}`,
  },
  error: {
    backgroundColor: `${colours.errorl1}`,
    color: `${colours.errord1}`,
  },
};

const iconContainerStyles: any = {
  default: { height: "24px", width: "22px" },
  inTable: {},
};

const iconStyles: any = {
  default: { height: "20px", color: colours.th1l1 },
  inTable: {
    height: "13px",
    color: colours.th1l1,
    position: "relative",
    top: "2px",
  },
};

interface IProps {
  type: string;
  showDismissButton?: boolean;
  hideIcon?: boolean;
  onDismiss?: any;
  children?: any;
  inTable?: boolean;
  backgroundColor?: string;
}

function Callout({
  type,
  showDismissButton,
  hideIcon,
  onDismiss,
  children,
  inTable,
  backgroundColor,
}: IProps) {
  const renderContents = () => {
    const InnerElement = inTable ? TableInnerContainer : InnerContainer;
    let IconElement;
    if (type === "info") {
      IconElement = InfoIcon;
    } else {
      IconElement = inTable ? AlertIcon : AlertIconSharp;
    }
    const iconContainerStyle = inTable
      ? iconContainerStyles["inTable"]
      : iconContainerStyles["default"];
    let iconStyle = inTable ? iconStyles["inTable"] : iconStyles["default"];

    if (type === "error") {
      iconStyle = { ...iconStyle };
      iconStyle.color = colours.errord1;
    }
    return (
      <>
        {["info", "warning", "error"].includes(type) && !hideIcon && (
          <IconContainer style={iconContainerStyle}>
            <IconElement style={iconStyle} />
          </IconContainer>
        )}
        <InnerElement>{children}</InnerElement>
        {showDismissButton && (
          <ButtonContainer>
            <CloseButton onClick={onDismiss} />
          </ButtonContainer>
        )}
      </>
    );
  };
  let containerStyle = containerStyles[type];

  if (backgroundColor) {
    containerStyle = { ...containerStyle };
    containerStyle.backgroundColor = backgroundColor;
  }

  return inTable ? (
    <TableCalloutContainer style={containerStyle}>
      {renderContents()}
    </TableCalloutContainer>
  ) : (
    <CalloutContainer style={containerStyle}>
      {renderContents()}
    </CalloutContainer>
  );
}

export default Callout;
